const getTimeStr = (time, isShort = false, interval = '-', formatStr = 'YYYY-MM-dd hh:mm:ss') => {
  if (isNumber(time)) time = new Date(time)
  if (!isDate(time)) return '-'
  let format = isShort ? `YYYY${interval}MM${interval}dd` : formatStr
  const date = {
    'M+': time.getMonth() + 1,
    'd+': time.getDate(),
    'h+': time.getHours(),
    'm+': time.getMinutes(),
    's+': time.getSeconds(),
    'q+': Math.floor((time.getMonth() + 3) / 3),
    'S+': time.getMilliseconds(),
  }
  if (/(y+)/i.test(format)) {
    format = format.replace(RegExp.$1, (time.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in date) {
    if (new RegExp('(' + k + ')').test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? date[k] : ('00' + date[k]).substr(('' + date[k]).length),
      )
    }
  }
  return format
}

const _debounce = (fn, delaytime) => {
  let timer = null
  return () => {
    if (timer) {
      clearTimeout(timer) //进入这里说明当前存在一个执行过程，并且同时又执行了一个相同事件，故取消当前的执行过程
    }
    timer = setTimeout(fn, delaytime)
  }
}

function eachAllChild(srcNode, callback) {
  callback(srcNode)
  if (srcNode.childrens.length > 0) {
    srcNode.childrens.map((item) => {
      eachAllChild(item, callback)
    })
  }
}

function toChinesNum(num) {
  let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'] //changeNum[0] = "零"
  let unit = ['', '十', '百', '千', '万']
  num = parseInt(num)
  let getWan = (temp) => {
    let strArr = temp
      .toString()
      .split('')
      .reverse()
    let newNum = ''
    for (var i = 0; i < strArr.length; i++) {
      newNum =
        (i == 0 && strArr[i] == 0
          ? ''
          : i > 0 && strArr[i] == 0 && strArr[i - 1] == 0
            ? ''
            : changeNum[strArr[i]] + (strArr[i] == 0 ? unit[0] : unit[i])) + newNum
    }
    return newNum
  }
  let overWan = Math.floor(num / 10000)
  let noWan = num % 10000
  if (noWan.toString().length < 4) noWan = '0' + noWan
  return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num)
}

function timeStamp(timest) {
  let seconds = timest / 60000
  var hour = parseInt(seconds / 60)
  var min = parseInt(seconds % 60)
  let hourStr = hour == 0 ? '' : `${hour}小时`
  let minStr = min == 0 ? '' : `${min}分`
  return `${hourStr}${minStr}`
}

function parseParam(param) {
  if (param == null) return ''
  var paramStr = ''
  for (var i in param) {
    if (param[i]) {
      paramStr += `${i}=${param[i]}&`
    }
  }
  return paramStr.substr(0, paramStr.length - 1)
}

function getDirectInfo(direct) {
  var rtDirect = {}
  if (direct > 27 && direct <= 72) {
    rtDirect.image = '45.png'
    rtDirect.direction = '东北'
  } else if (direct > 72 && direct <= 117) {
    rtDirect.image = '90.png'
    rtDirect.direction = '东'
  } else if (direct > 117 && direct <= 162) {
    rtDirect.image = '135.png'
    rtDirect.direction = '东南'
  } else if (direct > 162 && direct <= 207) {
    rtDirect.image = '180.png'
    rtDirect.direction = '南'
  } else if (direct > 207 && direct <= 252) {
    rtDirect.image = '225.png'
    rtDirect.direction = '西南'
  } else if (direct > 252 && direct <= 297) {
    rtDirect.image = '270.png'
    rtDirect.direction = '西'
  } else if (direct > 297 && direct <= 342) {
    rtDirect.image = '315.png'
    rtDirect.direction = '西北'
  } else {
    rtDirect.image = '0.png'
    rtDirect.direction = '北'
  }
  return rtDirect
}

function shouldJump(x1, y1, x2, y2, speed) {
  if ((x2 == 0 && y2 == 0) || (x2 == '114.059264' && y2 == '22.612487')) {
    return true
  }
  var distance = Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2))
  var thresholdValue = 0.00002
  if (speed === 10000) {
    thresholdValue = 0.00004
  } else if (speed === 20000) {
    thresholdValue = 0.00008
  } else if (speed === 40000) {
    thresholdValue = 0.00016
  } else if (speed === 80000) {
    thresholdValue = 0.00032
  } else if (speed === 160000) {
    thresholdValue = 0.00064
  }
  if (distance <= thresholdValue) {
    return true
  }
  return false
}

function isOutOfBounds(lnglat, bounds) {
  if (
    lnglat[0] <= bounds[0][0] ||
    lnglat[1] <= bounds[0][1] ||
    lnglat[0] >= bounds[1][0] ||
    lnglat[1] >= bounds[1][1]
  ) {
    return true
  }
  return false
}

function changeType(str) {
  return str
  // if (!str) return
  // let a = str.split('')
  // a.splice(2, 0, '·')
  // let b = a.join('')
  // return b
}

function getCameraLen(cameraLength) {
  let videoNums = 4
  if (cameraLength > 4 && cameraLength <= 6) {
    videoNums = 6
  } else if (cameraLength > 6 && cameraLength <= 9) {
    videoNums = 9
  } else if (cameraLength == 10) {
    videoNums = 10
  } else if (cameraLength > 10 && cameraLength <= 16) {
    videoNums = 16
  } else {
    videoNums = 4
  }
  return videoNums
}

//昨天00:00:00
function yesterdayStartTime() {
  return dateFormate(new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24))
}

//昨天23:59:59
function yesterdayEndTime() {
  return dateFormate(new Date(new Date(new Date().toLocaleDateString()).getTime() - 1000))
}

//前三天时间
function getPreThreeDayTime() {
  return dateFormate(new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24 * 3))
}

//前一个星期时间
function getPreWeekTime() {
  return dateFormate(new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24 * 7))
}

//前一个月时间
function getPreMonthTime() {
  return dateFormate(new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24 * 30))
}

//前三个月时间
function getPreThreeMonthTime() {
  return dateFormate(new Date(new Date(new Date().toLocaleDateString()).getTime() - 3600 * 1000 * 24 * 90))
}
function formatSeconds(value) {
  var secondTime = parseInt(value) // 秒
  var minuteTime = 0 // 分
  var hourTime = 0 // 小时
  var dayTime = 0 // 天
  var result = ''
  if (value < 60) {
    result = secondTime + '秒'
  } else {
    if (secondTime >= 60) {
      // 如果秒数大于60，将秒数转换成整数
      // 获取分钟，除以60取整数，得到整数分钟
      minuteTime = parseInt(secondTime / 60)
      // 获取秒数，秒数取佘，得到整数秒数
      secondTime = parseInt(secondTime % 60)
      // 如果分钟大于60，将分钟转换成小时
      if (minuteTime >= 60) {
        // 获取小时，获取分钟除以60，得到整数小时
        hourTime = parseInt(minuteTime / 60)
        // 获取小时后取佘的分，获取分钟除以60取佘的分
        minuteTime = parseInt(minuteTime % 60)
        if (hourTime >= 24) {
          // 获取天数， 获取小时除以24，得到整数天
          dayTime = parseInt(hourTime / 24)
          // 获取小时后取余小时，获取分钟除以24取余的分；
          hourTime = parseInt(hourTime % 24)
        }
      }
    }
    if (minuteTime > 0) {
      minuteTime = parseInt(minuteTime) >= 10 ? minuteTime : '0' + minuteTime
      result = '' + minuteTime + '分钟' + result
    }
    if (hourTime > 0) {
      result = '' + parseInt(hourTime) + '小时' + result
    }
    if (dayTime > 0) {
      result = '' + parseInt(dayTime) + '天' + result
    }
  }
  return result
}
/**
 * 将数字取整为10的倍数
 * formatInt(2345, 2, true)  -> 2400
 * formatInt(2345, 2. false) -> 2300
 * formatInt(2345, 3, true)  -> 3000
 * formatInt(2345, 3, false) -> 2000
 * @param {Number} num 需要取整的值
 * @param {Number} prec 需要用0占位的数量
 * @param {Boolean} ceil 是否向上取整
 */
function formatInt(num, prec = 2, ceil = true) {
  const mult = Math.pow(10, prec)
  return ceil ? Math.ceil(num / mult) * mult : Math.floor(num / mult) * mult
}
// 人员树
function orgTreeToPersonnelTree(data) {
  data.forEach((item) => {
    // 处理当前节点的 userList
    if (item.model.userList && item.model.userList.length) {
      // 将每个用户添加为当前节点的子节点
      item.model.userList.forEach((user) => {
        item.childrens.push({
          childrens: [],
          id: user.userId,
          orgName: user.userName,
          userId: user.userId,
          userName: user.userName,
          model: {
            type: 'user',
            orgName: user.userName,
            userList: [],
          },
        });
      });
    }
    // 递归处理子节点
    if (item.childrens.length) {
      orgTreeToPersonnelTree(item.childrens);
    }
  });
  console.log(data);
  return data;
}

/**
 * 用车事由icon
 * @param {String} val 用车事由文字
 */
function getCauseImage(val) {
  switch (val) {
    case '接送':
      return 'https://czg-wx.oss-cn-hangzhou.aliyuncs.com/image/cause_pickup.png'
    case '出差':
      return 'https://czg-wx.oss-cn-hangzhou.aliyuncs.com/image/cause_away.png'
    case '送货':
      return 'https://czg-wx.oss-cn-hangzhou.aliyuncs.com/image/cause_deliver.png'
    default:
      return 'https://czg-wx.oss-cn-hangzhou.aliyuncs.com/image/cause_other.png'
  }
}

/**
 * 图片，其他文件转为对应icon
 * @param {String} url 文件路径
 */
function getFileImage(url) {
  const obj = {
    pdf: 'https://czg-wx.oss-cn-hangzhou.aliyuncs.com/image/file_pdf.png',
    doc: 'https://czg-wx.oss-cn-hangzhou.aliyuncs.com/image/file_doc.png',
    docx: 'https://czg-wx.oss-cn-hangzhou.aliyuncs.com/image/file_doc.png',
    ppt: 'https://czg-wx.oss-cn-hangzhou.aliyuncs.com/image/file_ppt.png',
    pptx: 'https://czg-wx.oss-cn-hangzhou.aliyuncs.com/image/file_ppt.png',
    xls: 'https://czg-wx.oss-cn-hangzhou.aliyuncs.com/image/file_xls.png',
    xlsx: 'https://czg-wx.oss-cn-hangzhou.aliyuncs.com/image/file_xls.png',
  }
  const arr = url.split('.')
  const type = arr[arr.length - 1]
  return obj[type] || url
}

export {
  getTimeStr,
  _debounce,
  eachAllChild,
  toChinesNum,
  timeStamp,
  parseParam,
  getDirectInfo,
  shouldJump,
  isOutOfBounds,
  changeType,
  getCameraLen,
  getPreWeekTime,
  yesterdayStartTime,
  getPreThreeDayTime,
  yesterdayEndTime,
  getPreMonthTime,
  getPreThreeMonthTime,
  formatInt,
  formatSeconds,
  orgTreeToPersonnelTree,
  getCauseImage,
  getFileImage,
}
